export default Object.freeze(envs)
